import { useState, useMemo } from "react";
import { SettingsContext } from "./SettingsContext";
import { loadSettings, saveSettings } from "modules/helpers";

const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(loadSettings());

  const contextValue = useMemo(
    () => ({
      settings,
      updateSettings: (newSettings) => {
        saveSettings(newSettings);
        setSettings(newSettings);
      },
    }),
    [settings]
  );

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsProvider;
